module.exports = __webpack_public_path__ + "static/media/weather.cfee2a2c.png";